import { FormattedMessage } from 'react-intl';

import { TUploadBankEvidenceRequirement } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const UploadBankEvidence = ({
    status
}: TUploadBankEvidenceRequirement) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.upload_bank_evidence"
                    defaultMessage="Provide bank evidence"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.2_min"
                    defaultMessage="~ 2 Min."
                />
            }
            status={status}
        />
    );
};
